// Yedeğin uzak depoya (Cloudflare R2) itilmesi — panelin saf yardımcıları.
//
// Kural backend'dedir (services/backup_remote.py); buradaki fonksiyonlar
// yalnızca formu kurar ve sonucu çizer. Ayrışmamaları gereken tek yer rozet
// kümesidir: `backup_logs.remote_status` değerleri backend'deki
// `push_to_remote` sonuçlarıyla birebir aynı kalmalıdır.

// Formun düzenlenen alanları. Sır burada **yoktur**: sunucu onu hiç geri
// göndermez (yalnızca `secret_configured` bayrağı gelir) ve alan boş kaldıkça
// kayıtlı anahtara dokunulmaz.
export const REMOTE_FIELDS = [
  'enabled', 'account_id', 'endpoint', 'bucket', 'access_key_id', 'prefix',
];

export const remoteFormFromConfig = (config) => {
  const source = config || {};
  return {
    enabled: Boolean(source.enabled),
    account_id: source.account_id || '',
    endpoint: source.endpoint || '',
    bucket: source.bucket || '',
    access_key_id: source.access_key_id || '',
    prefix: source.prefix || 'yedekler',
    secret_access_key: '',
  };
};

// PATCH gövdesi: yalnızca değişen alanlar. Tam gövde göndermek kayıtlı
// anahtarı silerdi (sağlayıcı ayarlarının "yazma birleştirmedir" kuralı).
export const remoteChanges = (form, config) => {
  const saved = remoteFormFromConfig(config);
  const changes = {};
  REMOTE_FIELDS.forEach((key) => {
    const value = key === 'enabled' ? Boolean(form[key]) : String(form[key] ?? '').trim();
    if (value !== saved[key]) changes[key] = value;
  });
  const secret = String(form.secret_access_key || '').trim();
  if (secret) changes.secret_access_key = secret;
  return changes;
};

// Kova yolunun önizlemesi — backend'in `object_key` kalıbının aynısı:
// <önek>/<YYYY-AA-GG>/<dosya>. Yönetici kaydetmeden önce nereye yazılacağını
// görmelidir.
export const exampleRemoteKey = (prefix, now = new Date()) => {
  const clean = String(prefix || '')
    .replace(/[^A-Za-z0-9._\-/]+/g, '-')
    .split('/')
    .filter((part) => part && part !== '..')
    .join('/') || 'yedekler';
  const pad = (value) => String(value).padStart(2, '0');
  const day = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  const stamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}-140000`;
  return `${clean}/${day}/yedek-${stamp}.zip`;
};

// Geçmiş satırındaki uzak depo rozeti. `disabled` ve boş değer rozet
// üretmez: R2 tanımlı olmayan kurulumda her satıra "gönderilmedi" yazmak
// yöneticiyi olmayan bir arızayı aramaya iterdi.
export const REMOTE_STATUS = {
  uploaded: { label: "R2'ye yüklendi", badge: 'badge-green' },
  failed: { label: "R2'ye gönderilemedi", badge: 'badge-red' },
  pending: { label: "R2'ye gönderiliyor", badge: 'badge-yellow' },
  skipped: { label: 'yalnız SQL — R2 dışı', badge: 'badge-yellow' },
};

export const remoteStatusBadge = (log) => {
  if (!log || log.trigger === 'restore' || log.status !== 'completed') {
    return null;
  }
  return REMOTE_STATUS[log.remote_status] || null;
};

export const formatBackupDate = (value) => (
  value ? new Date(value).toLocaleString('tr-TR') : '—'
);

export const formatBackupSize = (bytes) => {
  const size = Number(bytes) || 0;
  if (size < 1024) return `${size} B`;
  const units = ['KB', 'MB', 'GB'];
  let value = size / 1024;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value.toFixed(1)} ${units[unit]}`;
};

export const BACKUP_STATUS_LABEL = {
  completed: 'tamamlandı',
  failed: 'başarısız',
  running: 'sürüyor',
};
// Geçmiş satırında işin cinsi: günlük görev, elle alınan yedek, indirilen
// anlık yedek ve geri yükleme aynı tabloda durur.
export const BACKUP_TRIGGER_LABEL = {
  schedule: 'otomatik',
  manual: 'elle',
  snapshot: 'anlık yedek',
  restore: 'geri yükleme',
};
export const BACKUP_STATUS_BADGE = {
  completed: 'badge-green',
  failed: 'badge-red',
  running: 'badge-yellow',
};
